'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BiddingInfoMock = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _mockData = require('./mockData');

var _delay = require('./delay');

var _delay2 = _interopRequireDefault(_delay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BiddingInfoMock = exports.BiddingInfoMock = {
    fetchCatalogBidding: function fetchCatalogBidding(catalogId) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var items = (0, _mockData.getTestItemsForCatalog)(catalogId);
                var itemIds = items.map(function (x) {
                    return x.itemId;
                });
                var infos = _mockData.mockBiddingInfos.filter(function (x) {
                    return itemIds.includes(x.itemId);
                });
                resolve({
                    data: infos
                });
            }, _delay2.default);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/mock/biddingInfo.js
// module id = Z/Sy
// module chunks = 57